export const articles = [
  {
    id: "article-1",
    slug: "2024-nian-du-tanhua-dashibang",
    title: "2024年度探花大师排行榜发布",
    excerpt: "盘点年度最具人气的探花大师，从作品质量到粉丝口碑，全方位解读行业标杆。",
    content: `
      <p>随着2024年即将结束，我们整理了这一年中最受关注的探花大师榜单。本榜单基于作品质量、用户口碑、创新程度等多维度指标综合评定。</p>
      <h2>榜单评选标准</h2>
      <p>我们的评选团队从以下几个维度对各位大师进行综合评估：</p>
      <ul>
        <li>作品原创性与创新性</li>
        <li>内容制作质量与技术水准</li>
        <li>用户满意度与口碑评价</li>
        <li>行业影响力与知名度</li>
      </ul>
      <h2>年度十大探花大师</h2>
      <p>以下是2024年度最受欢迎的十位探花大师，他们凭借出色的作品和专业的态度赢得了广大用户的认可。</p>
      <p>第一名至第十名的完整名单将在下周的年度盛典中正式公布，敬请期待。</p>
      <h2>行业趋势分析</h2>
      <p>2024年探花行业呈现出专业化、精品化的发展趋势。越来越多的创作者开始注重内容质量，行业整体水准有了显著提升。</p>
      <p>同时，随着技术的发展，直播、VR等新型呈现方式也开始在探花领域得到应用，为用户带来更加丰富的观赏体验。</p>
    `,
    image: "https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20stage%20with%20golden%20spotlights%2C%20dark%20luxury%20background%2C%20warm%20amber%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20photography&width=1200&height=675&seq=article-01&orientation=landscape",
    category: "top-master",
    categoryName: "顶级探花大师",
    tag: "热门",
    date: "2024-12-15",
    author: "探花编辑部",
    views: 12580,
    readTime: "8分钟",
  },
  {
    id: "article-2",
    slug: "tanhua-91-zuixin-xilie-jiexi",
    title: "探花91最新系列全面解析",
    excerpt: "深度解析91探花最新系列作品，从技术手法到内容创新，全面剖析。",
    content: `
      <p>91探花系列一直是探花爱好者关注的焦点。最新推出的系列作品在保持原有风格的基础上，进行了多项技术与内容创新。</p>
      <h2>技术升级亮点</h2>
      <p>本次系列在拍摄设备、后期制作等方面均有显著提升：</p>
      <ul>
        <li>采用4K超高清拍摄设备</li>
        <li>引入专业级调色流程</li>
        <li>优化音频采集与处理</li>
        <li>提升剪辑节奏与叙事流畅度</li>
      </ul>
      <h2>内容创新方向</h2>
      <p>除了技术升级，内容层面也做出了不少突破。更加注重场景搭建的真实感，以及人物表现的层次感。</p>
      <h2>用户反馈</h2>
      <p>新系列上线以来，用户反馈普遍积极。很多老用户表示新系列保持了91探花一贯的精品水准，同时在细节处理上更加考究。</p>
    `,
    image: "https://readdy.ai/api/search-image?query=Professional%20video%20camera%20setup%20with%20cinematic%20lighting%2C%20warm%20amber%20tones%2C%20dark%20studio%20background%2C%20editorial%20product%20photography%20style&width=1200&height=675&seq=article-02&orientation=landscape",
    category: "tanhua91",
    categoryName: "探花91",
    tag: "推荐",
    date: "2024-12-10",
    author: "内容评测组",
    views: 8920,
    readTime: "6分钟",
  },
  {
    id: "article-3",
    slug: "guonei-tanhua-hangye-qushi-baogao",
    title: "国内探花行业趋势报告",
    excerpt: "2024年国内探花行业发展趋势深度报告，市场规模、用户需求全面解读。",
    content: `
      <p>2024年国内探花行业经历了快速发展与深度调整并行的一年。本报告基于平台数据与行业调研，对当前市场状况进行全面分析。</p>
      <h2>市场规模概览</h2>
      <p>据估算，2024年国内探花相关市场规模达到新的高度，用户群体持续扩大，消费意愿稳步提升。</p>
      <h2>用户画像分析</h2>
      <p>当前探花内容的主要消费群体呈现以下特征：</p>
      <ul>
        <li>年龄分布：25-40岁为核心消费群体</li>
        <li>地域分布：一二线城市占比较高</li>
        <li>消费偏好：注重内容质量与更新频率</li>
        <li>使用场景：晚间休闲时段为主</li>
      </ul>
      <h2>发展趋势预测</h2>
      <p>展望2025年，行业将朝着更加规范化、精品化的方向发展。内容审核趋严的同时，优质创作者将获得更多发展空间。</p>
    `,
    image: "https://readdy.ai/api/search-image?query=Abstract%20business%20data%20visualization%20with%20warm%20amber%20gradients%2C%20flowing%20charts%20and%20graphs%2C%20modern%20digital%20art%2C%20minimalist%20clean%20design&width=1200&height=675&seq=article-03&orientation=landscape",
    category: "domestic",
    categoryName: "国内探花",
    tag: "独家",
    date: "2024-12-05",
    author: "行业研究中心",
    views: 6780,
    readTime: "10分钟",
  },
  {
    id: "article-4",
    slug: "dingji-tanhua-dashizhuanfang-chuangzuo",
    title: "顶级探花大师专访：创作背后的故事",
    excerpt: "独家专访三位顶级探花大师，揭秘创作灵感来源与幕后故事。",
    content: `
      <p>本期我们特别邀请到三位业内公认的顶级探花大师，与大家分享他们的创作心路历程。</p>
      <h2>大师A：以细节见真章</h2>
      <p>从业十年的大师A表示，每一次创作都是一次全新的挑战。他强调前期准备的重要性，包括场地选择、灯光布置、氛围营造等方方面面。</p>
      <h2>大师B：创新与传统的平衡</h2>
      <p>大师B认为，在尊重传统的基础上勇于创新是保持作品生命力的关键。他分享了如何在经典模式中寻找突破的心得。</p>
      <h2>大师C：与观众的共鸣</h2>
      <p>大师C则更注重与观众建立情感连接。他相信好的作品能够跨越屏幕，传递真实的情感体验。</p>
      <h2>创作背后的故事</h2>
      <p>三位大师都不约而同地提到了幕后团队的默默付出。一部精品作品的诞生，凝聚着摄影师、灯光师、后期制作等多方专业人才的共同努力。</p>
    `,
    image: "https://readdy.ai/api/search-image?query=Professional%20interview%20studio%20with%20elegant%20armchair%20and%20warm%20spotlight%2C%20dark%20moody%20background%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20style&width=1200&height=675&seq=article-04&orientation=landscape",
    category: "top-master",
    categoryName: "顶级探花大师",
    tag: "专访",
    date: "2024-11-28",
    author: "特约记者",
    views: 10230,
    readTime: "12分钟",
  },
  {
    id: "article-5",
    slug: "tanhua-jingxuan-meirixinpin-tuijian",
    title: "探花精选每日新品推荐",
    excerpt: "每日精选最新上线的探花内容，为您筛选最值得关注的优质作品。",
    content: `
      <p>欢迎来到每日精选推荐栏目。我们的编辑团队每日从海量内容中精心挑选，为您呈现最具价值的探花作品。</p>
      <h2>今日精选</h2>
      <p>今日共筛选出15部优质作品，涵盖国内探花、探花91、探花精选等多个类别。</p>
      <h2>推荐理由</h2>
      <p>入选今日精选的作品均满足以下条件：</p>
      <ul>
        <li>画质清晰，制作精良</li>
        <li>内容新颖，具有看点</li>
        <li>用户评价良好</li>
        <li>符合平台内容标准</li>
      </ul>
      <h2>观看指南</h2>
      <p>每部作品都配有详细的介绍说明，帮助您快速了解内容亮点，节省筛选时间。</p>
    `,
    image: "https://readdy.ai/api/search-image?query=Curated%20content%20showcase%20with%20warm%20golden%20light%2C%20elegant%20dark%20background%2C%20minimalist%20composition%2C%20premium%20editorial%20style%20photography&width=1200&height=675&seq=article-05&orientation=landscape",
    category: "selection",
    categoryName: "探花精选",
    tag: "每日更新",
    date: "2024-12-18",
    author: "精选编辑部",
    views: 5430,
    readTime: "5分钟",
  },
  {
    id: "article-6",
    slug: "tanhua-zhibo-zuixin-dongtai",
    title: "探花直播最新动态",
    excerpt: "实时掌握探花直播频道的最新动态，热门主播推荐与直播排期。",
    content: `
      <p>探花直播频道持续为用户带来精彩的实时内容。以下是本周直播安排与热门主播推荐。</p>
      <h2>本周直播排期</h2>
      <p>本周共有32场直播安排，涵盖不同主题与风格：</p>
      <ul>
        <li>周一：新人首秀专场</li>
        <li>周三：大师作品解析</li>
        <li>周五：粉丝互动直播</li>
        <li>周末：精品回顾连播</li>
      </ul>
      <h2>热门主播推荐</h2>
      <p>本周最受关注的三位主播各有特色，值得关注。</p>
      <h2>互动玩法升级</h2>
      <p>直播频道新增了弹幕互动、礼物打赏等功能，让用户能够更深入地参与到直播内容中。</p>
    `,
    image: "https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20colorful%20LED%20lights%2C%20professional%20setup%2C%20warm%20tones%2C%20modern%20minimalist%20design%2C%20editorial%20photography%20style&width=1200&height=675&seq=article-06&orientation=landscape",
    category: "live",
    categoryName: "探花直播",
    tag: "实时",
    date: "2024-12-17",
    author: "直播运营组",
    views: 7890,
    readTime: "4分钟",
  },
  {
    id: "article-7",
    slug: "tanhua-yiqu-jingdian-huigu",
    title: "探花一区经典回顾",
    excerpt: "回顾探花一区历年经典内容，重温那些难忘的精彩瞬间。",
    content: `
      <p>探花一区作为平台的经典专区，沉淀了大量优质内容。本期带您回顾历年最受欢迎的系列作品。</p>
      <h2>经典系列盘点</h2>
      <p>以下系列作品在用户中享有极高口碑：</p>
      <ul>
        <li>经典系列一：开创性作品，奠定行业标杆</li>
        <li>经典系列二：技术升级的代表作</li>
        <li>经典系列三：用户口碑最佳的常青系列</li>
      </ul>
      <h2>幕后故事</h2>
      <p>每部经典作品的诞生都有其独特的背景故事。我们整理了部分作品的创作花絮，带您了解镜头背后的故事。</p>
      <h2>重温指南</h2>
      <p>经典内容已按时间线和主题分类整理，方便新老用户按需浏览。</p>
    `,
    image: "https://readdy.ai/api/search-image?query=Vintage%20cinema%20projector%20with%20warm%20amber%20light%20beam%2C%20nostalgic%20atmosphere%2C%20dark%20background%2C%20editorial%20product%20photography%20style&width=1200&height=675&seq=article-07&orientation=landscape",
    category: "zone1",
    categoryName: "探花一区",
    tag: "经典",
    date: "2024-12-12",
    author: "内容运营组",
    views: 6540,
    readTime: "7分钟",
  },
  {
    id: "article-8",
    slug: "xinren-tanhua-chuangzuozhe-faxian",
    title: "新人探花创作者发现计划",
    excerpt: "发现潜力新人探花创作者，为行业注入新鲜血液与创意活力。",
    content: `
      <p>平台正式启动新人创作者发现计划，旨在挖掘有潜力的探花新人，为其提供展示才华的舞台。</p>
      <h2>计划亮点</h2>
      <p>本计划为新人创作者提供以下支持：</p>
      <ul>
        <li>专业技术培训与指导</li>
        <li>作品推广与流量扶持</li>
        <li>行业资源对接</li>
        <li>收益分成保障</li>
      </ul>
      <h2>入选标准</h2>
      <p>我们看重创作者的原创能力、专业态度和持续创作的热情。</p>
      <h2>报名通道</h2>
      <p>有意向的创作者可通过平台官方渠道提交申请，我们的审核团队将在7个工作日内给予反馈。</p>
    `,
    image: "https://readdy.ai/api/search-image?query=Young%20creative%20person%20in%20modern%20studio%20with%20warm%20lighting%2C%20professional%20equipment%2C%20inspiring%20atmosphere%2C%20editorial%20portrait%20photography%20style&width=1200&height=675&seq=article-08&orientation=landscape",
    category: "domestic",
    categoryName: "国内探花",
    tag: "新人",
    date: "2024-12-08",
    author: "人才招募组",
    views: 4320,
    readTime: "5分钟",
  },
];

export const getArticlesByCategory = (categoryId: string) => {
  return articles.filter((a) => a.category === categoryId);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug);
};

export const getRelatedArticles = (currentSlug: string, category: string) => {
  return articles
    .filter((a) => a.slug !== currentSlug)
    .filter((a) => a.category === category)
    .slice(0, 3);
};